// Shared CSV export helpers used by the admin Orders and Customers tabs.

export const csvCell = (value) => {
  const s = (value ?? "").toString();
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const downloadCSV = (headers, rows, filenamePrefix) => {
  const csv = [headers, ...rows].map((r) => r.map(csvCell).join(",")).join("\r\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  const stamp = new Date().toISOString().slice(0, 10);
  a.href = url;
  a.download = `${filenamePrefix}_${stamp}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const matchesSearch = (haystacks, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return haystacks.some((h) => (h || "").toString().toLowerCase().includes(q));
};
